import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withFontClassName from '../../hoc/with-font-class-name';
import withTranslate from '../../hoc/with-translate';
import styles from './member-filter.scss';

const MembersFilter = ({ className, contentFontClassName, value, onChange, count = 0, t }) =>
  <div className={classNames(styles.container, 'forum-text-color', contentFontClassName, className)}>
    <input
      className={styles.input}
      type="text"
      value={value}
      placeholder={t('member-filter.placeholder')}
      onChange={e => onChange(e.target.value)}
    />
    <span className={styles.count}>
      {count}
    </span>
  </div>;

MembersFilter.propTypes = {
  className: PropTypes.string,
  contentFontClassName: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  count: PropTypes.number,
  t: PropTypes.func,
};

export default _.flowRight(withFontClassName, withTranslate)(MembersFilter);



// WEBPACK FOOTER //
// ./app/components/member-header/member-filter.js